






































import { Vue, Component, Prop } from 'vue-property-decorator';
import { getAspectRatioFromUrl } from '@/common/ts/common';
import XcqManuscriptFooter from './XcqManuscriptFooter.vue';
import TopTag from './TopTag.vue';
import XcqImage from './XcqImage.vue';

@Component({
  components: {
    XcqManuscriptFooter,
    TopTag,
    XcqImage,
  },
})
export default class XcqManuscriptSmallImg extends Vue {
  @Prop({
    default: () => ({
      blockHeaderPic: '',
      blockName: '',
      blockBottomText: '',
      extText1: '',
      data: {},
      list: [],
    }),
  })
  blockInfo!: any;

  @Prop({ default: 349 }) width!: number;

  @Prop({ default: null }) blockDataInfo!: any;

  @Prop({ default: false }) showTop!: boolean;

  @Prop({ default: 0 }) topValue!: number;

  // 计算属性
  get dataInfo(): any {
    if (this.blockDataInfo) {
      return this.blockDataInfo;
    }
    if (this.blockInfo && this.blockInfo.data) {
      return this.blockInfo.data;
    }
    return null;
  }

  get imgList(): string[] {
    const imageUrl = this.dataInfo && this.dataInfo.imageUrl;
    if (imageUrl && Array.isArray(imageUrl)) {
      return imageUrl.slice(0, 3);
    }
    return [];
  }

  get imgWidth(): number {
    return parseInt(String(this.width * 0.329));
  }

  // 方法：计算图片高度
  getTopImgHeight(url: any): number {
    const ratio = getAspectRatioFromUrl(url) || 1.44;
    return Math.round(this.imgWidth / ratio);
  }

  // 点击事件处理
  handleClick(info: any): void {
    this.$emit('clickItem', info.jump, info);
  }
}
